import { render } from "./IntegratedSearch.vue?vue&type=template&id=d81a42ac&scoped=true"
import script from "./IntegratedSearch.vue?vue&type=script&lang=js"
export * from "./IntegratedSearch.vue?vue&type=script&lang=js"

import "./IntegratedSearch.vue?vue&type=style&index=0&id=d81a42ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81a42ac"]])

export default __exports__